export class UrpCodeRequestDto {
  codeId: number;
}
